import React from 'react';
import styles from './styles/GlobalStyles.module.css';

function ArtisticVision() {
    return (
        <div className={styles.container}>
            {/* Header */}
            <div className={styles.header}>
                <h1 className={styles.mainHeading}>Künstlerische Zielsetzung</h1>
            </div>

            {/* Textabschnitt */}
            <div className={styles.section}>
                <p className={styles.paragraph}>
                   In einer Zeit der Omnipräsenz technisch erzeugter Bilder versuche ich „personale Gegenbilder“ zu
                    entwerfen. Dies ist eine fast widersprüchliche Aufgabe, treibe ich doch Zeit meines Lebens in den
                    Wogen einer Bilderflut, die natürlich meine Wahrnehmung im Allgemeinen und die Wahrnehmung
                    von Bildern im Besonderen sowie die Ansprüche an diese mitformte und weiter formt.
                </p>
                <p className={styles.paragraph}>
                    Thema meiner Arbeit ist die Person in ihrer subjektiven und intersubjektiven Verfasstheit.
                    Die figürlichen Darstellungen sind in Bildern fixiertes Nachdenken, Reflexion über das Sein des
                    Menschen, Suche nach Sinn oder Un-Sinn, quasi-psychologische Selbst- und Fremdbefragung.
                </p>
                <p className={styles.paragraph}>
                    Dabei hilft ein prozessualer, langwieriger „Kompositionsweg“, der auch dem weitgehenden Verzicht
                    auf die Verwendung fotografischer Vorlagen geschuldet ist. Im Wechselspiel bzw. aus der
                    Kombination von Observation und Imagination erwächst eine Bildkonzeption. Der sich hieraus
                    ergebende Weg ist zwar durchaus festgefügt, beinhaltet also immer wieder aufgegriffene Stationen
                    oder Elemente, lässt jedoch auch Raum für Zufall und Spontaneität.
                </p>
                <p className={styles.paragraph}>
                    Gerade die Statik der Bildwelt – ein vermeintliches Hindernis bei der Darstellung von Inter-Aktion –
                    erlaubt es, z.B. Missverständnisse, die zwischen-menschlichem Geschehen innewohnen können,
                    pointiert darzustellen. Man kann Situationen konstruieren, die gleichzeitig erzählen, ohne ihr Rätsel
                    ganz preiszugeben.
                </p>
                <p className={styles.paragraph}>
                    Das Naturstudium ist unerlässlicher Bestandteil dieses Prozesses, aber auch – in Form der Plein-Air-
                    Malerei – eigenständig. Das Arbeiten im Freien ist mir aus mehreren Gründen wichtig: zum einen ist
                    es ein alle Sinne ursprünglich forderndes, im besten Fall auch kontemplatives Unterfangen, zum
                    anderen (und in gewissem Sinne dem Vorgehen hinsichtlich der figürlichen Kompositionen diametral
                    entgegengesetzt) gibt die „Vorlage“, die Perfektion einer Landschaft vor Augen die Möglichkeit zu
                    experimentieren. Variierende Fragestellungen (: interessiert eine Lichtstimmung, eine Besonderheit
                    der Vegetation oder Topografie?) verlangen mitunter unterschiedliche Umsetzungen.
                </p>
            </div>
        </div>
        
    );
    
    
}

export default ArtisticVision;
